<template>
	<div class="py-12 text-center">
		<div class="text-white text-2xl mb-4">
			Thank You!
		</div>
		<div class="text-white text-lg mb-10">
			Our representative will get in touch with you shortly to process the
			refund.
		</div>
	</div>
</template>

<script>
export default {
	name: 'Success',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
